
import { gql, useMutation } from '@apollo/client'
import { useSetRecoilState } from 'recoil'

import QueryStatus from '../utils/QueryStatus'
import Spinner from '../utils/Spinner'
import { setTokenCookie } from '../utils/authCookie'
import { userAtom } from './atoms'


const SIGN_IN = gql`
	mutation SignIn($email: String!, $password: String!) {
		signIn(email: $email, password: $password) {
			user {
				userId
				name
				email
				emailHash
				role
			}
			token
		}
	}`

export default function SignInForm() {

	const [signIn, { loading, error }] = useMutation(SIGN_IN)
	const setUser = useSetRecoilState(userAtom)

	function handleSubmit(event) {
		event.preventDefault()
		const formData = new FormData(event.target)
		const email = formData.get('email')
		const password = formData.get('password')	
		handleSignIn(email, password)
	}

	async function handleSignIn(email, password) {
		try {
			const { data } = await signIn({ variables: { email, password }})
			localStorage.setItem('token', data.signIn.token)
			setTokenCookie(data.signIn.token)
			setUser(data.signIn.user)
		} catch (error) { console.error(error) }
	}

	return <>
	
		<form onSubmit={handleSubmit} className='Form'>

			<fieldset>
				<legend>
					Email
				</legend>
				<input required
					name='email'
					type='email'
					autoComplete='username'
					className='Input'
				/>
			</fieldset>
			
			<fieldset>
				<legend>
					Password
				</legend>
				<input required
					name='password'
					type='password'
					className='Input'
					autoComplete='current-password'
				/>
			</fieldset>

			<div className='Submit'>

				<button type='submit' 
					className='Primary'
					disabled={!!loading}
				>
					Sign in
				</button>

				{ loading && <Spinner>Authenticating...</Spinner> }

			</div>

		</form>

		<QueryStatus error={error} />

	</>
}
